export const style = {
  alert: {
    status: 'warning',
    borderRadius: 'lg',
    padding: '4',
    bgColor: 'yellow.200',
  },
  flex: {
    flexDir: 'column',
    rowGap: '2',
    w: '100%',
  },
  alertDescription: {
    color: 'gray.500',
    fontSize: 'sm',
  },
  divider: {
    width: 'auto',
    marginInlineEnd: '-13px',
    marginInlineStart: '-13px',
    borderColor: 'gray.300',
  },
  alertTitle: {
    color: 'gray.500',
  },
};
